import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  onSnapshot,
  updateDoc,
  doc,
  serverTimestamp,
  addDoc,
} from "firebase/firestore";
import { db } from "../../services/firebaseConfig";
import { getAuth } from "firebase/auth";
import css from "./AdminPage.module.css";

const actionCodeSettings = {
  // coloque sua URL de continuação (onde o usuário vai completar o cadastro)
  url: "https://SEU_DOMINIO.com/onboard?mode=signup",
  // must be true for email link sign-in to work on mobile apps
  handleCodeInApp: true,
};

export default function AdminRegistrations() {
  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();

  useEffect(() => {
    const q = query(
      collection(db, "registrations"),
      where("status", "==", "pre-registration")
    );
    const unsub = onSnapshot(q, (snap) => {
      const list = [];
      snap.forEach((s) => list.push({ id: s.id, ...s.data() }));
      setPending(list);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  const approve = async (reg) => {
    try {
      // 1) opcional: criar placeholder doc em users_placeholders (ou você pode criar users depois do onboarding)
      // await addDoc(collection(db, "invitations"), {
      //   registrationId: reg.id,
      //   email: reg.email,
      //   name: reg.name,
      //   createdAt: serverTimestamp(),
      //   createdBy: auth.currentUser?.uid || null,
      // });

      // 2) enviar magic link por email
      // await sendSignInLinkToEmail(auth, reg.email, actionCodeSettings);

      // 3) atualizar registration
      await updateDoc(doc(db, "registrations", reg.id), {
        status: "approved",
        approvedAt: serverTimestamp(),
        approvedBy: auth.currentUser?.uid || null,
      });

      alert(`Link de convite enviado para ${reg.email}`);
    } catch (err) {
      console.error("Erro aprovar", err);
      alert("Erro ao aprovar: " + (err.message || err));
    }
  };

  if (loading) return <div>Carregando...</div>;

  return (
    <div className={css.container}>
      <h2>Inscrições pendentes</h2>
      {pending.length === 0 && <div>Nenhuma inscrição pendente.</div>}
      <ul>
        {pending.map((reg) => (
          <li key={reg.id} className={css.card}>
            <strong>{reg.name}</strong> — {reg.profession} — {reg.email}
            <div style={{ marginTop: "1rem" }}>
              <button onClick={() => approve(reg)} className="blueButton">
                Aprovar e enviar convite
              </button>
              <button
                style={{ marginTop: "1rem" }}
                className="redButton"
                onClick={() =>
                  updateDoc(doc(db, "registrations", reg.id), {
                    status: "rejected",
                    rejectedAt: serverTimestamp(),
                    rejectedBy: auth.currentUser?.uid || null,
                  })
                }
              >
                Rejeitar
              </button>
            </div>
            {reg.message && (
              <div style={{ marginTop: 6, fontStyle: "italic" }}>
                {reg.message}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
